import shadowDomPolyfill from '@webcomponents/shadydom/shadydom.min.js?url';
import resizeObserverPolyfill from 'resize-observer-polyfill/dist/ResizeObserver.global.js?url';
import webStreamsPolyfill from 'web-streams-polyfill/dist/polyfill.js?url';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).globalThis = window;

// требует global-this поэтому импорт не сверху
// подход с загрузкой этого полифилла через скрипт не работает, тк некст лезет в AbortController пораньше
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

const addLazyPolyfill = (name: string, src: string) => {
  console.warn('Will load ' + name + ' polyfill from ' + src);
  // https://github.com/vercel/next.js/blob/canary/packages/next/src/client/app-bootstrap.ts
  (self.__next_s = self.__next_s || []).push([
    src,
    {id: `pf-${name}`, type: 'text/javascript'},
  ]);
};

if (!('ReadableStream' in window)) {
 addLazyPolyfill('ReadableStream', webStreamsPolyfill);
}

if (!('ResizeObserver' in window)) {
  addLazyPolyfill('ResizeObserver', resizeObserverPolyfill);
}

if (!(document.head.attachShadow)) {
  addLazyPolyfill('ShadowDOM', shadowDomPolyfill);
}